import { nanoid } from 'nanoid';

// Generate a psuedo-random identifier. Primarily used for Tracing. It just
// needs to be good enough to identify a few spans near each other to help
// correlate spans that are not parent/child. This generates a value between
// 0-16 for as many `x`.
const TRACE_SESSION_ID =
  process.env.NODE_ENV === 'test' ? 'xxxxxxxxxxxxxxxxxxxxx' : nanoid();

export function getSessionId() {
  return TRACE_SESSION_ID;
}

// Allow a span to have a unique identifier tied to the user session. This
// should NEVER be a user_id or actual PII. Ideally, generate this once each
// time a page refreshes. It's just to correlate separate spans and help
// identify the user state (such as being offline or in an unrecoverable error
// state).
export const SESSION_ID_TAG = 'session.id';
